export function range(length: number, start = 0) {
  return Array.from({ length }, (_, i) => i + start);
}

export const removeImagesFromHTML = (htmlContent: string) => {
  return htmlContent.replace(/<img[^>]*>/g, '');
};
